import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { addCart } from "../redux/action";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Link } from "react-router-dom";
import configData from "../config.json";
import "../styles/product.css"; 

const Products = () => {
  const cart = useSelector((state) => state.handleCart);
  const dispatch = useDispatch();

  const [products, setProducts] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [categories, setCategories] = useState([]);
  const [featured, setFeatured] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // 🔹 Fetch Data
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        const [catRes, prodRes, featRes] = await Promise.all([
          fetch(`${configData.SERVER_URL}/category`),
          fetch(`${configData.SERVER_URL}/products`),
          fetch(`${configData.SERVER_URL}/featureProducts`)
        ]);

        const catData = await catRes.json();
        const prodData = await prodRes.json();
        const featData = await featRes.json();

        setCategories(catData);
        setProducts(prodData);
        setFiltered(prodData);
        setFeatured(featData);

      } catch (err) {
        console.error(err);
        setError("Failed to load products");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // 🔹 Filter
  const filterProduct = (catId) => {
    const updated = products.filter((p) => p.CategoryID === catId);
    setFiltered(updated);
  };

  // 🔹 Add to Cart
  const handleAddCart = (product) => {
    dispatch(addCart(product));
  };

  return (
    <div className="container py-4">

      {/* Header */}
      <div className="text-center mb-4">
        <h2 className="fw-bold text-success">Our Products</h2>
        <p className="text-muted">Browse and shop your favorite items</p>
      </div>

      {/* Error */}
      {error && <p className="text-danger text-center">{error}</p>}

      {/* Filters */}
      <div className="d-flex flex-wrap justify-content-center gap-2 mb-4">
        <button
          className="btn btn-sm btn-dark"
          onClick={() => setFiltered(products)}
        >
          All
        </button>

        {categories.map((cat) => (
          <button
            key={cat.CategoryID}
            className="btn btn-sm btn-outline-success d-flex align-items-center gap-1"
            onClick={() => filterProduct(cat.CategoryID)}
          >
            <img
              src={`${configData.IMAGE_URL}/categories/${cat.Image}`}
              height="20"
              alt={cat.CategoryName}
            />
            {cat.CategoryName}
          </button>
        ))}
      </div>

      {/* Products */}
      <div className="row g-4">
        {loading
          ? Array.from({ length: 8 }).map((_, i) => (
              <div key={i} className="col-6 col-md-4 col-lg-3">
                <Skeleton height={180} />
                <Skeleton height={20} className="mt-2" />
                <Skeleton height={20} width="60%" />
              </div>
            ))
          : filtered.length === 0 ? (
              <p className="text-center">No products found</p>
            ) : (
              filtered.map((product) => (
                <div
                  key={product.ProductID}
                  className="col-6 col-md-4 col-lg-3"
                >
                  <div className="card product-card h-100 border-0 shadow-sm">

                    <img
                      src={`${configData.IMAGE_URL}/products/${product.Image}`}
                      alt={product.ProductName}
                      className="p-3"
                      style={{ height: "180px", objectFit: "contain" }}
                    />

                    <div className="card-body text-center">
                      <h6 className="fw-semibold">
                        {product.ProductName}
                      </h6>

                      <p className="text-muted small">
                        {product.Description?.substring(0, 60)}...
                      </p>

                      <div className="fw-bold text-success">
                        ৳ {product.ProductPrice.toLocaleString()} / {product.munit}
                      </div>
                    </div>

                    <div className="card-footer bg-white border-0 text-center">
                      <Link
                        to={`/product/${product.ProductID}/${product.CategoryID}`}
                        className="btn btn-sm btn-outline-dark me-2"
                      >
                        View
                      </Link>

                      {product.UnitsInStock === 0 ? (
                        <button className="btn btn-sm btn-danger" disabled>
                          Out of Stock
                        </button>
                      ) : (
                        <button
                          className="btn btn-sm btn-success"
                          onClick={() => handleAddCart(product)}
                        >
                          Add
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              ))
            )}
      </div>

      {/* Featured Section */}
      <div className="mt-5">
        <h4 className="text-center text-success mb-3">
          Upcoming Products
        </h4>

        <div className="row g-3">
          {featured.map((product) => (
            <div
              key={product.ProductID}
              className="col-6 col-md-4 col-lg-3"
            >
              <div className="card h-100 border-0 shadow-sm">
                <img
                  src={`${configData.IMAGE_URL}/products/${product.Image}`}
                  alt={product.ProductName}
                  className="p-3"
                  style={{ height: "160px", objectFit: "contain" }}
                />
                <div className="card-body text-center">
                  <small className="text-muted">
                    {product.ProductName}
                  </small>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

    </div>
  );
};

export default Products;